import React from "react";
import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useTranslation } from 'react-i18next';
import faqData from "../data/faqData";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function FaqSection() {
    const { t } = useTranslation();
    UseScrollAnimation();
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    return (
        <div className="flex flex-col gap-[20px] py-6">

            <div className="space-y-4 ">
                {faqData.map((faq, index) => (
                    <div key={index} className="border rounded-xl p-4 shadow-md js-scroll fade-top">
                        <button
                            className="t-left w-full flex justify-between items-center text-lg font-medium"
                            onClick={() => toggleFAQ(index)}
                        >
                            {t(`${faq.question}`)}
                            <motion.div
                                animate={{ rotate: openIndex === index ? 180 : 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <ChevronDown className="w-5 h-5" />
                            </motion.div>
                        </button>
                        {openIndex === index && (
                            <motion.div
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                transition={{ duration: 0.3 }}
                                className="mt-2 text-gray-600"
                            >
                                {t(`${faq.answer}`)}
                            </motion.div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}